import React from 'react'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'

import { TtIcon } from '@23/react'

import Chyron, { ChyronSize } from './chyron'

import './j2s-intro-chyron.scss'

const J2SIntroChyron = () => {
  return (
    <Chyron
      size={ChyronSize.Medium}
      kickerPosition="top"
      kicker={intl.formatMessage({ defaultMessage: 'Go on camera' })}
    >
      <div className="j2s-intro-chyron">
        <h3 className="title">
          <FormattedMessage
            defaultMessage="You can now request access to go on camera.{linebreak}Just press the <wrapper>Go on camera</wrapper> button on top of the sidebar."
            values={{
              // eslint-disable-next-line react/no-unstable-nested-components
              wrapper: (...chunks) => (
                <span className="mic-icon-container">
                  <TtIcon className="mic-icon" name="record" library="23" />
                  {chunks}
                </span>
              ),
              linebreak: <br />,
            }}
          />
        </h3>
      </div>
    </Chyron>
  )
}

export default J2SIntroChyron
